import {z} from 'zod';

import i18n from '@dms/i18n';

import {
  AccountingMatrixDatagridConfig,
  getAccountingMatrixDatagridSharedFields,
} from '../../utils/accountingMatrixDatagridConfig';

export const getAccountingMatrixDatagridM2CentresConfig = (): AccountingMatrixDatagridConfig => ({
  dgCode: 'm2-centres',
  fields: [
    {
      name: 'code',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldCode'),
      type: 'text',
      isRequired: true,
    },
    {
      name: 'name',
      label: i18n.t('general.labels.name'),
      type: 'text',
      isRequired: true,
    },
    ...getAccountingMatrixDatagridSharedFields(),
  ],
  schema: z.object({
    code: z.string().min(1),
    name: z.string().min(1),
    billingInformation: z.string().min(1),
    validFrom: z.string(),
    validTo: z.string(),
  }),
});
